import React from 'react';
import { useMst } from '../models/WithWineState';
import { useObserver } from 'mobx-react-lite';
import { ConditionalContentProps } from '../types/ConditionalContentProps';
import styled from 'styled-components/macro';
import Logger from '../utils/logger';

const logger = new Logger('ConditionalContent');

const UnstyledConditionalContent: React.FC<ConditionalContentProps> = ({
  className,
  children,
  showif,
  text,
  action,
}) => {
  const stateTree = useMst();

  return useObserver(() => {
    if (
      (showif === 'loggedin' && !stateTree.session?.authenticated) ||
      (showif === 'loggedout' && stateTree.session?.authenticated)
    ) {
      return null;
    }

    let from = '';
    try {
      if (window) {
        from = `&from=${escape(window.location.href)}`;
      }
    } catch (e) {
      logger.error(e);
    }

    const timestamp = new Date().getTime() + '';
    const content = text ?? children;
    const classname = 'ww-widget ww-conditional-content ' + (className ?? '');

    let url;
    if (action) {
      url =
        action === 'login'
          ? `/user/login?cb=${timestamp}&login_info=login${from}`
          : action === 'logout'
          ? `/user/logout?cb=${timestamp}${from}`
          : action;
    } else {
      if (showif === 'loggedin') {
        url = `/user/logout?cb=${timestamp}${from}`;
      } else if (showif === 'loggedout') {
        url = `/user/login?cb=${timestamp}&login_info=login${from}`;
      }
    }

    return url ? (
      <a className={classname} href={url}>
        {content}
      </a>
    ) : (
      <span className={classname}>{content}</span>
    );
  });
};

export default styled(UnstyledConditionalContent)`
  font-size: inherit;
  font-family: inherit;
`;
